import React, {
  useCallback, useEffect, useMemo, useState, useRef,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { endOfWeek, format, startOfWeek } from 'date-fns';
import _, { drop } from 'lodash';
import { useParams } from 'react-router-dom';
import Scrollbar from 'react-scrollbars-custom';
import classNames from 'classnames';
import moment from 'moment-timezone'

import MaynLayout from '../Core/MainLayout';
import LabelWithCurrencySignComa from '../shared/LabelWithCurrencySignComa';
import DRP from '../Core/DRP/DRP';
import SearchIcon from '../Icons/SearchIcon';
import Input from '../Core/Input/Input';
// import CustomSelect from '../Core/Select/Select';
import CustomSelect from '../Core/CustomSelect'
import Button from '../Core/Button/Button';
import DataTable from '../Core/DataTableCustom/DTM';
import TableIcon from '../Icons/TableIcon';
import StyledCheckbox from '../Core/Checkbox/Checkbox';
import {
  workTimeSelector,
  totalSelector,
  workTimeLoadingSelector,
} from '../../store/worktime/selectors';
import {
  employeesSelector,
  JournalDataSelector,
  AdditionalRatesDataSelector,
} from '../../store/settings/selectors';
import { skillsSelector } from '../../store/skills/selectors';
import { placesSelector } from '../../store/places/selectors';
import { userSelector } from '../../store/auth/selectors';
import { changeStatusItems, getWorkTime, removeItems, patchEmptyHours } from '../../store/worktime/actions';
// import { getEmployees } from '../../store/employees/actions';
import { postLogbookEntry, postLogbookAddEntry, postLogbookComment } from '../../store/logbook/actions';
import { getJobTypes } from '../../store/jobTypes/actions';
import { getSkills } from '../../store/skills/actions';
import { getCustomCategories } from '../../store/customCategories/actions';
import { customCategoriesSelector } from '../../store/customCategories/selectors';
import { generateResourcesFromEmployees, getCheckedEmployeeIds, setCheckedEmployees, updateAllEmployees } from '../../components/TimeOff/Calendar/utils'
// import { addLogbookEntries } from '../../api'

import { loadEmployeesAll, loadLogbookJournal } from '../../store/settings/actions';
import avatar from '../Icons/avatar.png';
import Timeline from '../Core/Timeline/Timeline';
import { minutesToString } from '../Helpers';
import InfoCard from '../Core/InfoCard/InfoCard';
import CommentCard from '../Core/CommentCard/CommentCard';
import KioskCard from '../Core/KioskCard/KioskCard';
import PhotoCard from '../Core/PhotoCard/PhotoCard';
import GeolocationCard from '../Core/GeolocationCard/GeolocationCard';
import InfoIcon from '../Icons/InfoIcon';
import CheckboxIcon from '../Icons/CheckboxIcon';
import PendingIcon from '../Icons/PendingIcon';
import ApprovedIcon from '../Icons/ApprovedIcon';
import SuspendedIcon from '../Icons/SuspendedIcon';
import ApproveIcon from '../Icons/ApproveIcon';
import SuspendIcon from '../Icons/SuspendIcon';
import { downloadExcel, downloadPdf } from '../../store/reports/actions';
import { getPlaces } from '../../store/places/actions';
import usePermissions from '../Core/usePermissions';
import ApproveEmpty from '../Core/Dialog/ApproveEmpty';
import ApproveEmptySuccess from '../Core/Dialog/ApproveEmptySuccess';
import CategoryCard from '../Core/CategoryCard';

// import EditEntry from './EditEntry';
// import AddEntry from './AddEntry';
import EditComment from './EditComment';
import styles from './Logbook.module.scss';
import useCompanyInfo from '../../hooks/useCompanyInfo';
import EditCategory from '../Core/EditComment'
import AppGallery from '../Gallery'
import WorkTimeHistory from './WorkTimeHistory';
import BonusCard from '../Core/BonusCard';
import EditBonus from '../Core/EditBonus';
import FavoriteFilters from '../FavotiteFilters'
import { companyInfoSelector } from '../../store/company/selectors';
import LogbookEntryForm from './EntryForm'

const GlobeIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.648 22.803"
      {...props}
    >
      <g fill="#000" fillOpacity={0.85}>
        <path d="M24.55 10.324c-.389-.079-.79-.119-1.2-.119-.053 0-.105 0-.156.008a8.466 8.466 0 0 0-1.825-4.222c.09-.069.173-.139.252-.21a.606.606 0 0 0 .01-.888c-.254-.245-.625-.215-.908.01-.07.054-.142.107-.225.154a8.545 8.545 0 0 0-3.489-1.958c-.564-.572-1.195-.94-1.866-1.058a.629.629 0 0 0-.982-.001c-.674.116-1.307.485-1.873 1.06a8.545 8.545 0 0 0-3.49 1.957 1.756 1.756 0 0 1-.224-.155c-.283-.224-.654-.254-.908-.01a.606.606 0 0 0 .01.89c.079.07.162.14.251.209a8.508 8.508 0 0 0-1.884 4.761h-.184a.65.65 0 0 0-.644.644c0 .352.293.635.644.635h.183a8.503 8.503 0 0 0 1.91 4.801c-.098.075-.19.15-.276.229-.274.244-.254.644-.01.888.254.244.625.215.908-.01.08-.062.161-.123.255-.176a8.528 8.528 0 0 0 3.452 1.93c.55.562 1.166.93 1.819 1.059a.632.632 0 0 0 1.105-.002c.65-.13 1.262-.497 1.81-1.058.264-.074.523-.161.773-.263.211.407.468.787.764 1.132a9.893 9.893 0 0 1-3.904.796c-5.498 0-9.96-4.462-9.96-9.96 0-5.499 4.462-9.961 9.96-9.961 5.136 0 9.368 3.893 9.902 8.888Z" />
        <path d="M14.014 19.471v.959a.64.64 0 0 0 .086.321c-1.435-.287-2.688-1.712-3.48-3.848a8.924 8.924 0 0 1 1.269-.322c.542 1.463 1.296 2.529 2.125 2.89Zm3.572-.46c-.68.945-1.495 1.558-2.38 1.738a.627.627 0 0 0 .087-.32v-.961c.685-.305 1.318-1.089 1.822-2.181a5.95 5.95 0 0 0 .47 1.723Zm-6.07-3.633c-.448.09-.873.202-1.27.33a15.92 15.92 0 0 1-.513-3.677h1.307c.04 1.192.21 2.332.476 3.346Zm6.687-2.468c.025-.289.044-.582.053-.879h.686a5.906 5.906 0 0 0-.74.879Zm-6.701-5.448a15.696 15.696 0 0 0-.46 3.29H9.733c.039-1.318.216-2.54.503-3.622.396.13.82.24 1.265.332Zm8.061 3.29h-1.307a15.696 15.696 0 0 0-.46-3.29c.444-.092.868-.203 1.264-.332.287 1.083.464 2.304.503 3.622Zm-5.55-8.3v.868c-.838.363-1.6 1.442-2.143 2.934a8.892 8.892 0 0 1-1.261-.323c.801-2.189 2.083-3.634 3.555-3.894a.646.646 0 0 0-.15.414Zm4.675 3.479a8.89 8.89 0 0 1-1.261.323c-.542-1.486-1.3-2.562-2.134-2.93V2.45a.638.638 0 0 0-.154-.414c1.47.264 2.749 1.708 3.55 3.894Z" />
        <path d="M15.293 2.451v4.026c2.364-.08 4.23-.634 5.43-1.575.283-.224.654-.254.908-.01a.606.606 0 0 1-.01.89c-1.214 1.096-3.588 1.873-6.328 1.978v2.992h5.519c-.7.309-1.333.746-1.87 1.28h-3.649v3.05c.656.024 1.29.088 1.892.187a6.127 6.127 0 0 0-.123 1.26 12.63 12.63 0 0 0-1.769-.164v4.065a.65.65 0 0 1-.645.644.642.642 0 0 1-.634-.644v-4.065c-2.369.077-4.238.624-5.44 1.575-.283.224-.654.253-.908.01-.244-.245-.264-.645.01-.89 1.215-1.097 3.594-1.875 6.338-1.978v-3.05H5.859a.642.642 0 0 1-.644-.636.65.65 0 0 1 .644-.644h8.155V7.76C11.27 7.656 8.89 6.88 7.676 5.781a.606.606 0 0 1-.01-.888c.254-.245.625-.215.908.01 1.202.941 3.071 1.496 5.44 1.574V2.451c0-.351.283-.644.634-.644a.65.65 0 0 1 .645.644Z" />
        <path d="M28.31 16.504c0 2.715-2.265 4.96-4.96 4.96-2.715 0-4.961-2.226-4.961-4.96 0-2.715 2.246-4.961 4.96-4.961 2.725 0 4.962 2.236 4.962 4.96Zm-5.517-2.89v2.45h-1.758a.607.607 0 0 0-.605.596c0 .332.263.606.605.606h2.363a.596.596 0 0 0 .606-.606v-3.047a.598.598 0 0 0-.606-.586.598.598 0 0 0-.605.586Z" />
      </g>
    </svg>
  )
}

const getTimezoneDiff = (from, to) => {
  if (!from || !to) {
    return {
      value: 0,
      formatted: `+00:00`
    }
  }
  const getOffset = (tz) => {
    if (tz.startsWith('UTC')) {
      return moment.parseZone(`2000-01-01T00:00:00${tz.slice(3)}`).utcOffset();
    }

    return moment.tz(tz).utcOffset();
  };

  const diff = getOffset(to) - getOffset(from);

  const sign = diff >= 0 ? '+' : '-';
  const hours = String(Math.floor(Math.abs(diff) / 60)).padStart(2, '0');
  const minutes = String(Math.abs(diff) % 60).padStart(2, '0');

  return {
    value: diff,
    formatted: `${sign}${hours}:${minutes}`,
  }
}

const getTimeDifference = (time1, time2) => {
  const diff = moment(time1, 'HH:mm').diff(moment(time2, 'HH:mm'))
  const duration = moment.duration(diff)

  return duration
}

const formatWorkingTime = (duration, breakTime) => {
  const workingTime = getTimeDifference(duration, breakTime)
  return `${Math.floor(workingTime.asHours())}:${String(workingTime.minutes()).padStart(2, '0')}`
}

const timeToMinutes = (time) => {
  if (!time) return 0;
  const [hours, minutes] = time.split(':');
  return Number(hours) * 60 + Number(minutes);
}

const minutesToTime = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const min = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
}

let columns = [
  { label: 'Status', field: 'status', checked: true },
  { label: 'Employee', field: 'employee', checked: true },
  { label: 'Skill', field: 'skill', checked: true },
  { label: 'Place', field: 'place', checked: true },
  { label: 'Photo', field: 'comments', checked: true },
  {
    label: 'Comments', field: 'comments_photo', checked: true,
    // cellRenderer: (row) => {
    //   if (Array.isArray(row.comments) && row.comments.length > 0) {
    //     const [comment] = row.comments
    //     return comment.comment
    //   }
    //   return null
    // },
  },
  { label: 'Shift', field: 'shift_name', checked: true},
  { label: 'Task', field: 'task_name', checked: true},
  { label: 'Job Type', field: 'jobType', checked: true },
  { label: 'Start', field: 'start', checked: true },
  { label: 'End', field: 'end', checked: true },
  {
    label: 'Duration, h',
    field: 'duration',
    checked: true,
    cellRenderer: (row) => {
      const durationValue = row?.duration || '00:00';
      const timezoneValue = row?.companyTimezone;
      const timezoneDiff = getTimezoneDiff(timezoneValue, row.timezone)

      if (!timezoneDiff.value) {
        return durationValue
      }

      return (
        <div style={{display: 'flex', alignItems: 'center', gap: 4}}>
          { durationValue }
          <div style={{backgroundColor: '#edf7fa', color: '#1d88fc', display: 'flex', alignItems: 'center', fontSize: 12}}>
            <GlobeIcon />
            { timezoneDiff.formatted }
          </div>
        </div>
      )
    },
  },
  {
    label: 'Working time', field: 'working_time', checked: true,
    cellRenderer: (row) => formatWorkingTime(row.duration, row.break_time),
  },
  { label: 'Unpaid time, h', field: 'empty_hours', checked: true },
  { label: 'Break time, h', field: 'break_time', checked: true },
  { label: 'Regular hours, h', field: 'working_hours', checked: true },
  { label: 'Holiday time, h', field: 'holiday_time', checked: true },
  { label: 'Night time, h', field: 'night_duration', checked: true },
  { label: <LabelWithCurrencySignComa label='Cost' />, field: 'cost', checked: true },
  { label: <LabelWithCurrencySignComa label='Earnings' />, field: 'charge', checked: true },
  { label: <LabelWithCurrencySignComa label='Profit' />, field: 'profit', checked: true },
  {
    label: <LabelWithCurrencySignComa label='Bonus' />,
    field: 'additional_bonus',
    checked: true,
    cellRenderer: (row) => {
      const rawValue = row?.additional_bonus;

      if (rawValue === null || typeof rawValue === 'undefined' || rawValue === '') {
        return '0.00';
      }

      const normalizedValue = typeof rawValue === 'string' ? rawValue.replace(/,/g, '') : rawValue;
      const parsedValue = Number(normalizedValue);

      if (Number.isNaN(parsedValue)) {
        return rawValue;
      }

      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(parsedValue);
    },
  },
];
let columnsWidth = {
  status: 280,
  employee: 'auto',
  date: 250,
  skill: 120,
  start: 100,
  end: 100,
  place: 140,
  jobType: 140,
  duration: 180,
  charge: 140,
  cost: 140,
  profit: 140,
};
const permissionsConfig = [
  {
    name: 'places',
    module: 'create_places',
  },
  {
    name: 'jobs',
    module: 'create_jobs',
  },
  {
    name: 'cost',
    module: 'cost_earning',
    permission: 'logbook_costs',
  },
  {
    name: 'profit',
    module: 'profitability',
    permission: 'logbook_profit',
  },
  {
    name: 'logbook_delete_logs',
    permission: 'logbook_delete_logs',
  },
  {
    name: 'logbook_edit_comments',
    permission: 'logbook_edit_comments',
  },
  {
    name: 'logbook_edit_categories',
    permission: 'logbook_can_edit_categories',
  },
  {
    name: 'logbook_add_logs',
    permission: 'logbook_add_logs',
  },
  {
    name: 'use_approval_flow',
    module: 'use_approval_flow',
  },
  {
    name: 'approval_flow',
    module: 'use_approval_flow',
    permission: 'logbook_requests',
  },
  {
    name: 'approval_flow_in_place',
    module: 'use_approval_flow',
    permission: 'logbook_requests_in_place',
  },
  {
    name: 'comments_photo',
    module: 'comments_photo',
  },
  {
    name: 'Shift_name',
    module: 'shift_name',
  },
  {
    name: 'night_rates',
    module: 'night_rates',
  },
  {
    name: 'schedule_shift',
    module: 'schedule_shift',
    permission: 'schedule_create_and_edit',
  },
  {
    name: 'schedule_simple',
    module: 'schedule_simple',
    permission: 'schedule_create_and_edit',
  },
  {
    name: 'schedule_module',
    permission: 'schedule_module_access',
  },
  {
    name: 'custom_category',
    module: 'custom_category',
  },
  {
    name: 'logbook_edit_logs',
    permission: 'logbook_edit_logs',
  },
  {
    name: 'empty_hours_enabled',
    module: 'empty_hours_enabled',
  },
];

const getCustomCategoriesOfItem = (item, allCustomCategories) => {
  if (!item) {
    return []
  }
  
  return allCustomCategories.map((cat) => {
    switch (cat.field_type) {
      case 'entry_field':
        return {
          id: cat.id,
          name: cat.name,
          value: item.custom_category_sessions?.reverse()?.find(s => s.custom_category_id === cat.id)?.value || '',
        }
      case 'dropdown_fields':
        return {
          id: cat.id,
          name: cat.name,
          dropdown_fields: cat.dropdown_fields.map((field) => {
            return {
              ...field,
              value: item.custom_category_dropdown_session?.reverse()?.find(s => s.custom_category_id === cat.id && s.custom_category_dropdown_field_id === field.id)?.value || '',
            }
          }),
        }
    }
  }).filter(Boolean)
}

const setCheckedColumns = (columns, employeeId) => {
  if (!employeeId) {
    return columns
  }
  const storedColumnsState = localStorage.getItem(`logbook_columns_${employeeId}`)
  if (storedColumnsState) {
    try {
      const parsedColumnsState = JSON.parse(storedColumnsState)
      return columns.map(column => {
        return {
          ...column,
          checked: column.field in parsedColumnsState ? parsedColumnsState[column.field] : column.checked,
        }
      })
    } catch (error) {
      return columns
    }
  }
  return columns
}

export default () => {
  const { getDateFormat } = useCompanyInfo();
  const companyInfo = useSelector(companyInfoSelector);

  const [itemsArray, setItemsArray] = useState([]);
  const [columnsArray, setColumnsArray] = useState([]);
  const [columnsWidthArray, setColumnsWidthArray] = useState({});

  const [selectedItem, setSelectedItem] = useState(null);
  const [checkedItems, setCheckedItems] = useState([]);
  const [loading, setLoading] = useState(null);
  const AdditionalRates = useSelector(AdditionalRatesDataSelector);

  const [dateRange, setDateRange] = useState({
    startDate: moment().startOf('isoWeek').toDate(),
    endDate: moment().endOf('isoWeek').toDate(),
  });

  const [places, setPlaces] = useState([]);
  const [skills, setSkills] = useState([]);
  const [search, setSearch] = useState('');
  const [employees, setEmployees] = useState([]);
  // const [isOpenEditEntry, setIsOpenEditEntry] = useState(false);
  const [isOpenEditComment, setIsOpenEditComment] = useState(false);
  // const [isOpenAddEntry, setIsOpenAddEntry] = useState(false);
  const allCustomCategories = useSelector(customCategoriesSelector);
  const [approveEmptyVisible, setApproveEmptyVisible] = useState(false);
  const [approveEmptySuccess, setApproveEmptySuccess] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const wTime = useSelector(workTimeSelector);
  const workTimeLoading = useSelector(workTimeLoadingSelector);
  const { users: employeesStore } = useSelector(employeesSelector);
  const getTotal = useSelector(totalSelector);
  const selectSkills = useSelector(skillsSelector);
  const selectPlaces = useSelector(placesSelector);
  const user = useSelector(userSelector);
  const journal = useSelector(JournalDataSelector);
  const { id: companyId } = useParams();
  const permissions = usePermissions(permissionsConfig);

  const [total, setTotal] = useState({ sallary: 0, cost: 0, profit: 0 });
  const [logbook_employee, setLogbookEmployee] = useState(!!user?.employee?.logbook_employee);
  const [sortStatus, setSortStatus] = useState([]);

  const editCategoryRef = useRef(null)
  const galleryRef = useRef(null)
  const editBonusRef = useRef(null)
  const logbookEntryFormRef = useRef(null)

  moment.updateLocale('lt', {
    weekdays: ["Sekmadienis", "Pirmadienis", "Antradienis", "Trečiadienis", "Ketvirtadienis", "Penktadienis", "Šeštadienis"],
    months: [
      "Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"
    ],
    // Add any additional locale settings as needed
  });

  moment.locale(localStorage.getItem('i18nextLng') || 'en');

  const { cost: costEarning, profit: profitAccess } = permissions
  const companyTimezone = companyInfo?.timezone || '';

  const workTime = useMemo(() => {
    return wTime.map((day) => {
      return {
        ...day,
        items: day.items.map(({ profitability = {}, ...rest }) => {
          return {
            ...rest,
            ...profitability,
            companyTimezone,
          };
        }),
        ...costEarning ? { cost: day.cost } : {},
        ...profitAccess ? { profit: day.profit, charge: day.sallary } : {},
      };
    })
  }, [profitAccess, costEarning, companyTimezone, wTime])

  useEffect(() => {
    dispatch(getJobTypes(companyId));
    dispatch(getPlaces(companyId));
    dispatch(getSkills(companyId));
    dispatch(loadLogbookJournal(companyId));
    dispatch(loadEmployeesAll(companyId, {page: 'logbook'}));
    dispatch(getCustomCategories(companyId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  useEffect(() => {
    if (Array.isArray(workTime)) {
      if (logbook_employee) {
        let newArrange = [];
        let employeeDays = {};

        const partFormat = getDateFormat({
          'YY.MM.DD': 'YYYY. MMMM, DD',
          'DD.MM.YY': 'DD. MMMM, YYYY',
          'MM.DD.YY': 'MMMM. DD, YYYY',
        });

        workTime.map((item) => {
          let { items } = item;
          items.map((it) => {
            if (!employeeDays[it.employee_id]) {
              employeeDays[it.employee_id] = []
            }
            employeeDays[it.employee_id].push(
              {
                ...it,
                date: moment(item.date, 'YYYY-MM-DD').format(`dddd, ${partFormat}`),
                // date: companyInfo?.dateFormat ? moment(item.date, companyInfo.dateFormat.replaceAll('.', '-').replaceAll('YY', 'YYYY')).format(`dddd, ${partFormat}`) : moment(item.date).format(`dddd, ${partFormat}`),
                status: statusSelector(it.works[0].status, it?.stoped_by),
                night_duration: it.additional_rate?.holiday && it.additional_rate.ignore_holiday_night_time && it.holiday_minutes ? '00:00' : it.night_duration,
              })

            if (!newArrange.find((i) => i.employeeId === it.employee_id)) {
              newArrange.push(
                {
                  ...item,
                  employeeId: it.employee_id,
                  label: it.employee
                })
            }

            return it;
          });

          return item;
        });

        newArrange = newArrange.map((item) => {
          return {
            ...item,
            date: '',
            id: item.label,
            companyTimezone,
            duration: minutesToTime([...employeeDays[item.employeeId]].reduce(function(sum, current) { return sum*1 + timeToMinutes(current.duration)*1; }, 0)),
            working_time: minutesToTime([...employeeDays[item.employeeId]].reduce(function(sum, current) {
              return sum*1 + timeToMinutes(current.duration)*1 - timeToMinutes(current.break_time)*1;
            }, 0)),
            working_hours: minutesToTime([...employeeDays[item.employeeId]].reduce(function(sum, current) { return sum*1 + timeToMinutes(current.working_hours)*1; }, 0)),
            break_time: minutesToTime([...employeeDays[item.employeeId]].reduce(function(sum, current) { return sum*1 + timeToMinutes(current.break_time)*1; }, 0)),
            holiday_time: minutesToTime([...employeeDays[item.employeeId]].reduce(function(sum, current) { return sum*1 + timeToMinutes(current.holiday_time)*1; }, 0)),
            night_duration: minutesToTime([...employeeDays[item.employeeId]].reduce(function(sum, current) { return sum*1 + timeToMinutes(current.night_duration)*1; }, 0)),
            cost: parseFloat([...employeeDays[item.employeeId]].reduce(function(sum, current) { return sum*1 + parseFloat(current.cost.replace(/,/g, ''))*1; }, 0)).toFixed(2),
            charge: parseFloat([...employeeDays[item.employeeId]].reduce(function(sum, current) { return sum*1 + parseFloat(current.charge.replace(/,/g, ''))*1; }, 0)).toFixed(2),
            profit: parseFloat([...employeeDays[item.employeeId]].reduce(function(sum, current) { return sum*1 + parseFloat(current.profit.replace(/,/g, ''))*1; }, 0)).toFixed(2),
            items: [...employeeDays[item.employeeId]],
          };
        })

        setItemsArray(newArrange ? newArrange.filter(({ items }) => items.length) : []);

        setColumnsArray(columnsArray.map((item) => { return {...item, field: (item.label === 'Employee') ? 'date' : item.field, label: (item.label === 'Employee') ? 'Date' : item.label } } ))
      } else {
        setItemsArray(workTime.map((item) => {
          let { items } = item;

          if (items?.length) {
            items = items
              .map((it) => {
                return {
                  ...it,
                  status: statusSelector(it.works[0].status, it?.stoped_by),
                  night_duration: it.additional_rate?.holiday && it.additional_rate.ignore_holiday_night_time && it.holiday_minutes ? '00:00' : it.night_duration,
                }
              })
              .filter((it) => !sortStatus.some((status) => 
                status === it.status ||
                (status === 'Pending' && it.status === 'Left geozone') ||
                (status === 'Pending' && it.status === 'Out of Geozone') ||
                (status === 'Pending' && it.status === 'Turned off geolocation') ||
                (status === 'Pending' && it.status === 'Turned off internet or app') ||
                (status === 'Pending' && it.status === 'Logged off the APP') ||
                (status === 'Pending' && it.status === 'Stopped by System') ||
                (status === 'Pending' && it.status === 'Stopped by Manager')
            ));
          }

          const partFormat = getDateFormat({
            'YY.MM.DD': 'YYYY. MMMM, DD',
            'DD.MM.YY': 'DD. MMMM, YYYY',
            'MM.DD.YY': 'MMMM. DD, YYYY',
          });

          let new_label = moment(item.date, 'YYYY-MM-DD').format(`dddd, ${partFormat}`).toUpperCase();
          if (new_label === 'INVALID DATE') {
            new_label = moment(item.date).format(`dddd, ${partFormat}`).toUpperCase();
          }
          return {
            ...item,
            label: new_label === 'INVALID DATE' ? item.id : new_label,
            working_time: minutesToTime(items.reduce((sum, current) => (
              sum + timeToMinutes(current.duration) - timeToMinutes(current.break_time)
            ), 0)),
            items,
          };
        }).filter(({ items }) => items.length));

        setColumnsArray(columnsArray.map((item) => { return {...item, field: (item.label === 'Date') ? 'employee' : item.field, label: (item.label === 'Date') ? 'Employee' : item.label } } ))
      }
     
      setColumnsWidthArray({...columnsWidth});
      setTotal(getTotal);
    }

    // eslint-disable-next-line
  }, [workTime, getTotal, sortStatus, logbook_employee]);

  useEffect(() => {
    let allColumnsArray = columns.filter((column) => {
      switch (column.field) {
        case 'place':
          return permissions.places
        case 'jobType':
          return permissions.jobs
        case 'charge':
        case 'profit':
          return permissions.profit
        case 'cost':
          return permissions.cost
        case 'holiday_time':
          return AdditionalRates.holiday
        case 'night_duration':
          return AdditionalRates.night_time && permissions.night_rates
        case 'shift_name':
          return permissions.schedule_simple || permissions.schedule_shift
        case 'task_name':
          return permissions.schedule_simple
        case 'empty_hours':
          return permissions.empty_hours_enabled
        case 'comments':
          return journal.end_day_photo
        case 'comments_photo':
          return journal.end_day_comment
        case 'additional_bonus':
          return journal.additional_bonus
        default:
          return true;
      }
    });

    if (permissions.custom_category) {
      //need add it before 'start' column
      const customCategories = allCustomCategories.map((category) => {
        return {
          label: category.name,
          field: `custom_category_${category.id}`,
          checked: true,
        };
      });

      allColumnsArray = allColumnsArray.reduce((acc, item) => {
        if (item.field === 'start') {
          return [...acc, ...customCategories, item];
        }
        return [...acc, item];
      }, []);
    }

    // eslint-disable-next-line
    setColumnsArray(setCheckedColumns(allColumnsArray, user?.employee.id));
    // eslint-disable-next-line
  }, [permissions, setColumnsArray, allCustomCategories, AdditionalRates, journal.end_day_photo]);

  useEffect(() => {
    setLoading(workTimeLoading);
  }, [workTimeLoading]);

  useEffect(() => {
    if (Array.isArray(selectSkills)) {
      setSkills(selectSkills.map(s => ({...s, checked: false, title: s.label, isEmployee: true})));
    }
  }, [selectSkills]);

  useEffect(() => {
    if (Array.isArray(selectPlaces)) {
      setPlaces(selectPlaces.map(p => ({...p, checked: false, title: p.name, isEmployee: true})));
    }
  }, [selectPlaces]);

  useEffect(() => {
    if (Array.isArray(employeesStore)) {
      setEmployees(generateResourcesFromEmployees(employeesStore));
    }
  }, [employeesStore])

  useEffect(() => {
    sendRequest()
  }, [dateRange])

  const sorting = (status) => {
    setSortStatus((prevState) => {
      if (prevState.find((i) => i === status)) {
        return prevState.filter((i) => i !== status);
      }
      return [...prevState, status];
    });
  };

  const icons = {
    status: [
      {
        value: 'Pending',
        icon: <PendingIcon />,
        onClick: (status) => sorting(status),
      },
      {
        value: 'Approved',
        icon: <ApprovedIcon />,
        onClick: (status) => sorting(status),
      },
      //(permissions.use_approval_flow && journal.approve_flow) ?
      {
        value: 'Suspended',
        hideTop: !(permissions.use_approval_flow && journal.approve_flow),
        icon: <SuspendedIcon />,
        onClick: (status) => sorting(status),
      },// : {},
      {
        value: 'Stopped by System',
        hideTop: true,
        icon: <PendingIcon />,
        onClick: (status) => sorting(status),
      },
      {
        value: 'Stopped by Manager',
        hideTop: true,
        icon: <PendingIcon />,
        onClick: (status) => sorting(status),
      },
      {
        value: 'Left geozone',
        hideTop: true,
        icon: <PendingIcon />,
        onClick: (status) => sorting(status),
      },
      {
        value: 'Out of Geozone',
        hideTop: true,
        icon: <PendingIcon />,
        onClick: (status) => sorting(status),
      },
      {
        value: 'Turned off geolocation',
        hideTop: true,
        icon: <PendingIcon />,
        onClick: (status) => sorting(status),
      },
      {
        value: 'Turned off internet or app',
        hideTop: true,
        icon: <PendingIcon />,
        onClick: (status) => sorting(status),
      },
      {
        value: 'Logged off the APP',
        hideTop: true,
        icon: <PendingIcon />,
        onClick: (status) => sorting(status),
      },
    ],
  };

  const statusSelector = (status, stoped) => {
 
    switch (status) {
      case 0: {
        if (stoped === 'manager') {
          return 'Stopped by Manager';
        } else if (stoped === 'geolocation_leave') {
          return "Left geozone"
        } else if (stoped === 'geoleave_with_comment') {
          return "Out of Geozone"
        } else if (stoped === 'geolocation_off') {
          return "Turned off geolocation"
        } else if (stoped === 'geolocation_app') {
          return "Turned off internet or app"
        } else if (stoped === 'logout') {
          return "Logged off the APP"
        } else if (stoped === 'daily_overtime' || stoped === 'weekly_overtime') {
          return 'Stopped by System';
        } else if (stoped === 'manager') {
          return 'Stopped by Manager';
        }
        
        return 'Pending';
      }
      case 1: {
        if (stoped === 'daily_overtime' || stoped === 'weekly_overtime') {
          return 'Stopped by System';
        } else if (stoped === 'manager') {
          return 'Stopped by Manager';
        }
        
        return 'Approved';
      }
      case 2:
        return 'Suspended';
      case 'approve':
      case 'Approve':
        return 1;
      case 'suspend':
      case 'Suspend':
        return 2;
      default:
        return 0;
    }
  };

  const stopedSelector = (stoped) => {
    switch (stoped) {
      case 'daily_overtime':
        return t('Clock stopped by Daily Overtime');
      case 'weekly_overtime':
        return t('Clock stopped by Weekly Overtime');
      case 'manager':
        return t('Clock stopped by Manager');
      case 'geolocation_leave':
        return t('Clock stopped by leaving geozone');
      case 'geoleave_with_comment':
        return t('Finished out of Geozone');
      case 'geolocation_off':
        return t('Clock stopped by turning off geolocation');
      case 'geolocation_app':
        return t('Clock stopped by turning off internet or app');
      case 'logout':
        return t('Clock stopped by logging off the app');
      default:
        return '';
    }
  };

  const sendRequest = (props = {}) => {
    const { startDate, endDate } = dateRange;
    if (startDate && !endDate) return;

    const employeesArr = getCheckedEmployeeIds(employees)
    const skillsArr = skills.filter(s => s.checked).map((s) => s.id);
    const placesArr = places.filter(p => p.checked).map((p) => p.id);

    dispatch(getWorkTime(companyId, {
      startDate: startDate ? format(startDate, 'yyyy-MM-dd HH:mm:ss') : '',
      endDate: endDate ? format(endDate, 'yyyy-MM-dd HH:mm:ss') : '',
      search,
      employeesArr,
      skillsArr,
      placesArr,
      ...props,
    })).then(() => {
      setCheckedItems([]);
      setSelectedItem(null);
    });
  }

  const selectionHandler = useCallback((itemId, value) => {
    const checkedItms = [];
    const setCheckedToAll = (state) => {
      const arrayCopy = [...state];
      return arrayCopy.map((group) => {
        const items = group.items.map((row) => {
          const newRowObj = { ...row };
          if (typeof itemId === 'string' && itemId === 'all') {
            newRowObj.checked = value;
          } else if (Array.isArray(itemId) && itemId.includes(newRowObj.id)) {
            newRowObj.checked = value;
          } else if (newRowObj.id === itemId) {
            newRowObj.checked = value;
          }
          if (newRowObj.checked) checkedItms.push(newRowObj);
          return newRowObj;
        });
        return { ...group, items };
      });
    };
    setItemsArray(setCheckedToAll);
    setCheckedItems(checkedItms);
  }, []);

  const sortHandler = useCallback((field, asc) => {
    const sortNumFunction = (a, b) => (asc ? (a[field] - b[field]) : (b[field] - a[field]));
    const sortFunction = (a, b) => {
      if (typeof a[field] === 'number' && typeof b[field] === 'number') {
        return sortNumFunction(a, b);
      }
      if (asc) {
        return a[field].toString().localeCompare(b[field]);
      }
      return b[field].toString().localeCompare(a[field]);
    };
    const sortItems = (array) => {
      const arrayCopy = [...array];
      return arrayCopy.map((group) => {
        const items = [...group.items];
        items.sort(sortFunction);
        return { ...group, items };
      });
    };
    setItemsArray(sortItems);
  }, []);

  const Delimiter = () => (<div className={styles.delimiter} />);

  const applyHandler = () => {
    sendRequest();
  };

  const rowSelectionHandler = (selectedRow) => {
    setSelectedItem(selectedItem?.id === selectedRow?.id ? null : selectedRow);
  };

  const onPlacesSelectChange = (checkedPlaces) => {
    setPlaces(checkedPlaces)
  };

  const onSkillsSelectChange = (selectedSkills) => {
    setSkills(selectedSkills);
  };

  const onEmployeesSelectChange = (selectedEmployees) => {
    setEmployees(selectedEmployees);
  };

  const onChangeFilterEmployee = (value) => {
    if (user.user && user.employee) {
      setLogbookEmployee(value)
    }
  };
  const searchHandler = (term) => {
    setSearch(term);
  };

  const deleteItems = () => {
    const confirm = window.confirm('Are you sure you want to delete this entry/entries?');
    if (confirm) {
      dispatch(removeItems(companyId, { items: checkedItems.map((item) => (item.id)) })).then(() => {
        sendRequest();
      }).catch();
    }
  };

  const changeItemStatus = (status, entryId = null) => {
    const confirm = window.confirm(`Are you sure you want to ${status} this entry/entries?`);
    if (confirm) {
      dispatch(changeStatusItems(companyId, {
        items: entryId ?? checkedItems.map((item) => (item.id)),
        status: statusSelector(status),
      })).then(() => {
        sendRequest();
      }).catch();
    }
  };

  const downloadReport = (action, ext) => {
    setLoading(true);

    const { startDate, endDate } = dateRange;

    const employeesArr = getCheckedEmployeeIds(employees)
    const skillsArr = skills.filter(s => s.checked).map((emp) => emp.id);
    const placesArr = places.filter(p => p.checked).map((emp) => emp.id);

    const requestObj = {
      startDate: startDate ? format(startDate, 'yyyy-MM-dd HH:mm:ss') : null,
      endDate: endDate ? format(endDate, 'yyyy-MM-dd HH:mm:ss') : null,
      // places: null,
      // jobTypes: null,
      placesArr,
      employeesArr,
      skillsArr,
      columnsArray
    };

    dispatch(action(companyId, requestObj,'logbook')).then(({ data }) => {
      // eslint-disable-next-line no-shadow
      const { startDate, endDate } = dateRange;
      // Insert a link that allows the user to download the PDF file
      const link = document.createElement('a');
      link.download = _.isEmpty(dateRange) ? `Report_${format(new Date(), 'yyyy-MM-dd')}.${ext}`
        : `Report_${format(startDate,
          'yyyy-MM-dd')}_${format(endDate,
          'yyyy-MM-dd')}.${ext}`;
      link.href = `data:application/octet-stream;base64,${data}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      setLoading(false);
    }).catch();
  };

  const handleClickSaveEntry = (data) => {
    dispatch(postLogbookEntry(companyId, data, sendRequest));
    // setIsOpenEditEntry(false);
  };

  // const handleClickAddEntry = async (data) => {
  //   // dispatch(postLogbookAddEntry(companyId, data, sendRequest));
  //   // setIsOpenAddEntry(false);
  //   const res = await addLogbookEntries(companyId, data)
  //   sendRequest()
  // };


  const handleClickSaveComment = (data) => {
    dispatch(postLogbookComment(companyId, data, sendRequest));
    setIsOpenEditComment(false);
  };

  const handleApproveEmpty = (id, type) => {
    setApproveEmptyVisible({id, type});
  };

  const handleEditCategory = (category) => {
    editCategoryRef.current.open({
      value: category.value,
      title: category.name,
      hideLimit: true,
      data: category,
    });
  }

  const handleEditBonus = (selectedItem) => {
    editBonusRef.current.open({
      value: selectedItem.additional_bonus,
      data: selectedItem,
    });
  }

  const handleSaveCategory = ({value, data}) => {
    const isDropdown = Array.isArray(data.dropdown_fields)
    const updates = {
      ...(isDropdown ? {
        custom_category_dropdown_session: data.dropdown_fields
      } : {
        [`custom_category_${data.id}`]: value,
      })
    }
    const post = {
      ...selectedItem,
      comment: (selectedItem.comments && selectedItem.comments[0] ? selectedItem.comments[0].comment : ''),
      ...updates,
    }
    handleClickSaveEntry(post)
    editCategoryRef.current.close()
  }

  const onApproveEmpty = (id, type) => {
    dispatch(patchEmptyHours(companyId, {id, type})).then(() => {
      setApproveEmptySuccess(true);
      sendRequest();
    }).catch();
  };

  const selectedItemPlace = places.find((place) => place.id === selectedItem?.place_id || place.name === selectedItem?.place);

  const handleChangeActiveFavoriteFilter = (data) => {
    const updatedEmployees = data.employees ? setCheckedEmployees(employees, data.employees || [], true) : updateAllEmployees(employees, false)
    setPlaces(places.map(p => ({...p, checked: data.places?.includes(p.id)})))
    setSkills(skills.map(s => ({...s, checked: data.skills?.includes(s.id)})))
    setEmployees(updatedEmployees)
    setDateRange({
      startDate: data.start ? moment(data.start, 'DD-MM-YYYY').toDate() : moment().startOf('isoWeek').toDate(),
      endDate: data.end ? moment(data.end, 'DD-MM-YYYY').toDate() : moment().endOf('isoWeek').toDate(),
    })
    setSearch(data.search || '')

    const filters = {
      startDate: data.start ? moment(data.start, 'DD-MM-YYYY').format('YYYY-MM-DD HH:mm:ss') : moment().startOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
      endDate: data.end ? moment(data.end, 'DD-MM-YYYY').format('YYYY-MM-DD HH:mm:ss') : moment().endOf('isoWeek').format('YYYY-MM-DD HH:mm:ss'),
      search: data.search || search,
      employeesArr: getCheckedEmployeeIds(updatedEmployees),
      skillsArr: data.skills || skills.filter(s => s.checked).map((s) => s.id),
      placesArr: data.places || places.filter(p => p.checked).map((p) => p.id),
    }

    sendRequest(filters)
  }

  const EmployeeInfo = () => {
    const ignoreNightTimeInHoliday = selectedItem?.additional_rate?.holiday && selectedItem?.additional_rate?.ignore_holiday_night_time && selectedItem?.holiday_minutes
    
    const isApproval = (
      (permissions.approval_flow
        || (permissions.approval_flow_in_place && user?.employee?.place?.[0]?.id === selectedItem?.place_id)
      ) && !!journal.approve_flow
    );
    
    const customCategoriesItem = getCustomCategoriesOfItem(selectedItem, allCustomCategories)
    return (
      <div className={styles.employeeInfo}>
        <div className={styles.hero}>
          {
            permissions.logbook_edit_logs && (
              <Button onClick={() => {

                // setIsOpenEditEntry(true)
                logbookEntryFormRef.current.show(selectedItem)
              }} inverse inline size='small'>
                {t('Edit')}
              </Button>
            )
          }
          <img src={selectedItem.photo || avatar} className={styles.avatar} alt={selectedItem.employee} width='71' height='72' />
          <div className={styles.employeeName}>{selectedItem.employee}</div>
          <div className={styles.date}>
            {
              `${t(moment(selectedItem.works[0].started_at).format('ddd'))}, `+
              moment(selectedItem.works[0].started_at)
                .format(`${getDateFormat({
                  'YY.MM.DD': 'YYYY, MMMM, DD',
                  'DD.MM.YY': 'DD, MMMM, YYYY',
                  'MM.DD.YY': 'MMMM, DD, YYYY',
                })}`)
            }
          </div>
          <Delimiter />
          {
            selectedItem && (
              <>
                <Scrollbar
                  style={{ height: `calc(100vh - 318px - ${isApproval ? '64px' : '0px'})` }}
                  removeTracksWhenNotUsed
                  trackXProps={{
                    renderer: ({ elementRef, ...restProps }) => (
                      <span
                        {...restProps}
                        ref={elementRef}
                        className={classNames(styles.scrollbarTrackX, { trackX: true })}
                      />
                    ),
                  }}
                  trackYProps={{
                    renderer: ({ elementRef, ...restProps }) => (
                      <span
                        {...restProps}
                        ref={elementRef}
                        className={classNames(styles.scrollbarTrackY, { trackY: true })}
                      />
                    ),
                  }}
                >
                  <Timeline
                    works={selectedItem.works}
                    breaks={selectedItem.breaks}
                    night={ignoreNightTimeInHoliday ? [] : selectedItem.night}
                    empty={selectedItem.empty}
                    total={selectedItem.total_work_sec}
                    startMinute={selectedItem?.work_started_at || selectedItem.started_at}
                    startTime={selectedItem?.work_start || selectedItem.start}
                    endTime={selectedItem?.work_end || selectedItem.end}
                    withTimeBreaks
                  />
                  <Delimiter />
                  {
                    selectedItem.stoped_by && (
                      <>
                        <div className={styles.stopedBy}>
                          <PendingIcon className={styles.stopedIcon} />
                          {stopedSelector(selectedItem.stoped_by)}
                        </div>
                        <Delimiter />
                      </>
                    )
                  }
                  {
                    selectedItem.event_started_at && (
                      <>
                        <InfoCard
                          type='scheduled_hours'
                          time={selectedItem}
                          eventMinutes={selectedItem.event_minutes}
                        />
                        <Delimiter />
                      </>
                    )
                  }
                  <InfoCard
                    type='total'
                    time={selectedItem}
                    showRange
                  />
                  <Delimiter />
                  {
                    selectedItem.start_minutes_difference && (
                      <>
                        <InfoCard
                          type='start_empty'
                          time={selectedItem}
                          durationSec={selectedItem.start_minutes_difference*60}
                          onApproveEmpty={permissions.logbook_edit_logs ? () => handleApproveEmpty(selectedItem.id, 'start') : false}
                        />
                        <Delimiter />
                      </>
                    )
                  }
                  <InfoCard
                    type='working'
                    time={selectedItem}
                    durationSec={getTimeDifference(selectedItem.duration, selectedItem.break_time).asSeconds()}
                  />
                  <Delimiter />
                  <InfoCard
                    type='regular'
                    time={selectedItem}
                    durationSec={selectedItem.working_hours_sec}
                  />
                  <Delimiter />
                  {
                    selectedItem.end_minutes_difference && (
                      <>
                        <InfoCard
                          type='end_empty'
                          time={selectedItem}
                          durationSec={selectedItem.end_minutes_difference*60}
                          onApproveEmpty={permissions.logbook_edit_logs ? () => handleApproveEmpty(selectedItem.id, 'end') : false}
                        />
                        <Delimiter />
                      </>
                    )
                  }
                  {
                    (AdditionalRates.holiday) && (
                      <>
                        <InfoCard
                          type='holiday'
                          time={selectedItem}
                          durationSec={selectedItem.holiday_minutes*60}
                        />
                        <Delimiter />
                      </>
                    )
                  }
                  {
                    (AdditionalRates.night_time && permissions.night_rates && !ignoreNightTimeInHoliday) && (
                      <>
                        <InfoCard
                          type='night'
                          time={selectedItem}
                          durationSec={selectedItem.total_night_sec}
                        />
                        <Delimiter />
                      </>
                    )
                  }
                  <InfoCard
                    type='break'
                    time={selectedItem}
                    durationSec={selectedItem.total_break_sec}
                  />
                  <Delimiter />
                  {
                    (permissions.profit) && (
                      <>
                      <InfoCard
                        type='earning'
                        time={selectedItem}
                      />
                      <Delimiter />
                      </>
                    )
                  }
                  {
                    (permissions.cost) && (
                      <>
                      <InfoCard
                        type='cost'
                        time={selectedItem}
                      />
                      <Delimiter />
                      </>
                    )
                  }
                  {
                    (permissions.profit) && (
                      <>
                      <InfoCard
                        type='profit'
                        time={selectedItem}
                      />
                      <Delimiter />
                      </>
                    )
                  }
                  {
                    (selectedItem.stoped_by !== 'manager' && permissions.comments_photo && journal.end_day_comment && !!selectedItem.comments?.length) ? (
                      <CommentCard
                        onEditComment={() => setIsOpenEditComment(true) }
                        photo={journal.end_day_photo ? selectedItem.comments[0].photo : null}
                        photos={journal.end_day_photo ? selectedItem.comments[0].photos : []}
                        //width={journal.end_day_photo ? selectedItem.comments[0].photo_width : null}
                        //height={journal.end_day_photo ? selectedItem.comments[0].photo_height : null}
                        canEdit={permissions.logbook_edit_comments}
                        comment={selectedItem.comments[0].comment}
                      />
                    ) : null
                  }
                  {
                    journal.additional_bonus
                      ? <>
                          <Delimiter />
                          <BonusCard
                            selectedItem={selectedItem}
                            onEdit={handleEditBonus} />
                        </>
                      : null
                  }
                  {
                    customCategoriesItem.length
                      ? <div style={{flexDirection: 'column', gap: 15, display: 'flex', paddingTop: 15}}>
                         {
                            customCategoriesItem.map((category, i) => {
                              return (
                                <CategoryCard
                                  key={i}
                                  category={category}
                                  canEdit={permissions.logbook_edit_categories}
                                  onEditComment={handleEditCategory} />
                              )
                            })
                         }
                        </div>
                      : null
                  }
                  {
                    selectedItem.kiosk_photo && (selectedItem.kiosk_photo?.photo_in || selectedItem.kiosk_photo?.photo_out) && (
                      <KioskCard
                        name={selectedItem.kiosk_photo.kiosk_name}
                        photoIn={selectedItem.kiosk_photo.photo_in}
                        photoOut={selectedItem.kiosk_photo.photo_out}
                      />
                    )
                  }

                  {
                    selectedItem.work_time_photo && (selectedItem.work_time_photo.photo_in || selectedItem.work_time_photo.photo_out) && (
                      <PhotoCard
                        photoIn={selectedItem.work_time_photo.photo_in}
                        photoOut={selectedItem.work_time_photo.photo_out}
                      />
                    )
                  }

                  {
                    selectedItemPlace && selectedItemPlace.coordinates && selectedItem.stoped_by && selectedItem.stoped_by === 'geolocation_leave' && selectedItem.coordinates && (
                      <GeolocationCard
                        coordinates={selectedItem.coordinates}
                        place={selectedItemPlace}
                      />
                    )
                  }

                  {
                    selectedItemPlace && selectedItemPlace.coordinates && selectedItem.stoped_by && selectedItem.stoped_by === 'geoleave_with_comment' && selectedItem.coordinates && (
                      <GeolocationCard
                        coordinates={selectedItem.coordinates}
                        place={selectedItemPlace}
                        comment={selectedItem.geoleave_comment}
                      />
                    )
                  }
                  <WorkTimeHistory
                    history={selectedItem.work_time_history}
                    selectedItem={selectedItem} />
                </Scrollbar>
                {
                  isApproval && (
                    <div className={styles.actionButtons}>
                      <button
                        className={styles.approve}
                        onClick={() => changeItemStatus('approve', selectedItem.id)}
                      >
                        <span aria-hidden><ApproveIcon aria-hidden /></span>
                        <span>{t('Approve')}</span>
                      </button>
                      <button
                        className={styles.suspend}
                        onClick={() => changeItemStatus('suspend', selectedItem.id)}
                      >
                        <span aria-hidden><SuspendIcon aria-hidden /></span>
                        <span>{t('Suspend')}</span>
                      </button>
                    </div>
                  )
                }
              </>
            )
          }
        </div>
        {/* <EditEntry
          open={isOpenEditEntry}
          handleClose={() => setIsOpenEditEntry(false)}
          selectedItem={selectedItem}
          customCategoriesItem={customCategoriesItem}
          onClickSave={handleClickSaveEntry}
        /> */}
        <EditComment
          open={isOpenEditComment}
          handleClose={() => setIsOpenEditComment(false)}
          selectedItem={selectedItem}
          onClickSave={handleClickSaveComment}
        />
      </div>
    );
  };

  const MultipleEntries = () => {
    const isApproval = (
      (permissions.approval_flow
      || (
        permissions.approval_flow_in_place
        && checkedItems.every((item) => user?.employee?.place?.[0]?.id === item.place_id)
      )) && !!journal.approve_flow
    );

    return (
      <div className={styles.multipleEntries}>
        <div className={styles.header}>
          <InfoIcon />
          <Delimiter />
          {t('Multiple entries selection')}
        </div>
        <div className={styles.content}>
          <div className={styles.topBlock}>
            <CheckboxIcon className={styles.checkboxIcon} />
            <div className={styles.entryTitle}>
              {`${checkedItems.length} `}
              {t(checkedItems.length === 1 ? 'entry' : 'entries')}
            </div>
            <div className={styles.entryDescription}>
              {t('selected')}
            </div>
          </div>
          <div className={styles.bottomBlock}>
            <PendingIcon className={styles.clockIcon} />
            <div className={styles.entryTitle}>
              {minutesToString(checkedItems.map((item) => item.net_duration).reduce((a, b) => a + b))}
            </div>
            <div className={styles.entryDescription}>
              {t('Total Hours')}
            </div>
          </div>
        </div>
        <div className={styles.actions}>
          {
            isApproval && (
              <>
                <Button onClick={() => changeItemStatus('approve')} green fillWidth>
                  {checkedItems.length === 1 ? t('Approve') : t('Approve All')}
                </Button>
                <Button onClick={() => changeItemStatus('suspend')} yellow fillWidth>
                  {checkedItems.length === 1 ? t('Suspend') : t('Suspend All')}
                </Button>
              </>
            )
          }
          {
            permissions.logbook_delete_logs && (
              <Button onClick={deleteItems} danger fillWidth>
                {checkedItems.length === 1 ? t('Delete') : t('Delete All')}
              </Button>
            )
          }
        </div>
      </div>
    );
  };

  const settingsCustom = () => {

    return (
      <div className={styles.settingsCustom}>
        <StyledCheckbox
          label={t('Filter by Employee')}
          checked={logbook_employee}
          onChange={() => onChangeFilterEmployee(!logbook_employee)}
        />
      </div>
    );
  }

  const handleOpenGallery = (data) => {
    galleryRef.current.open(data[0]?.photos)
  }

  const isFiltersSet = places.filter(p => p.checked).map((item) => item.id).length || skills.filter(s => s.checked).map((item) => item.id).length || getCheckedEmployeeIds(employees).length || search.length > 0;

  return (
    <MaynLayout>
      <div className={styles.container}>
        <div className={styles.leftContent}>
          <header onClick={() => setSelectedItem(null)} className={styles.appHeader}>
            <DRP initRange={dateRange} onChange={setDateRange} />
            <div className={styles.hideOn660}>
              <Delimiter />
              <Input
                icon={<SearchIcon />}
                placeholder={`${t('Search')}...`}
                width='100%'
                height='36px'
                value={search}
                onChange={(e) => searchHandler(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && applyHandler()}
              />
            </div>
            <div className={styles.hideOn936}>
              <Delimiter />
              <CustomSelect
                placeholder={t('All places')}
                buttonLabel={t('Filter')}
                items={places ?? []}
                onChange={onPlacesSelectChange}
                width='auto'
                withSearch={true}
              />
            </div>

            <div className={styles.hideOn750}>
              <Delimiter />
              <CustomSelect
                placeholder={t('All skills')}
                buttonLabel={t('Filter')}
                items={skills ?? []}
                onChange={onSkillsSelectChange}
                width='auto'
                withSearch={true}
              />
            </div>

            <div className={styles.hideOn815}>
              <Delimiter />
              <CustomSelect
                placeholder={t('All employees')}
                buttonLabel={t('Filter')}
                items={employees ?? []}
                onChange={onEmployeesSelectChange}
                width='auto'
                withSearch={true}
              />
            </div>
            <div className={styles.hideOn815}>
              <Delimiter />
              <FavoriteFilters
                companyId={companyId}
                onChangeActive={handleChangeActiveFavoriteFilter}
                type="logbook"
                active={places.length && skills.length && employees.length}
                currentFilters={{
                  places: places.filter(p => p.checked).map((item) => item.id),
                  skills: skills.filter(s => s.checked).map((item) => item.id),
                  employees: getCheckedEmployeeIds(employees),
                  start: dateRange.startDate ? moment(dateRange.startDate).format('DD-MM-YYYY') : null,
                  end: dateRange.endDate ? moment(dateRange.endDate).format('DD-MM-YYYY') : null,
                  search,
                }} />
            </div>
            <div className={styles.hideOn936}>
              <Delimiter />
              <Button disabled={!isFiltersSet} onClick={applyHandler}>{t('Apply')}</Button>
            </div>
          </header>
          <Delimiter/>
          <DataTable
            data={itemsArray || []}
            columns={columnsArray || []}
            columnsWidth={columnsWidthArray || {}}
            onColumnsChange={data => {
              const columnsState = data.reduce((acc, column) => ({
                ...acc,
                [column.field]: column.checked
              }), {})
              localStorage.setItem(`logbook_columns_${user?.employee?.id}`, JSON.stringify(columnsState))
              setColumnsArray(data)
            }}
            selectable
            sortable
            loading={loading}
            onSelect={selectionHandler}
            onSort={sortHandler}
            lastPage={workTime?.last_page}
            activePage={workTime?.current_page}
            itemsCountPerPage={workTime?.per_page}
            totalItemsCount={workTime?.total}
            //handlePagination={console.log}
            selectedItem={selectedItem}
            total={total}
            setSelectedItem={rowSelectionHandler}
            verticalOffset='200px'
            fieldIcons={icons}
            statusClickable
            sortStatus={sortStatus}
            downloadExcel={() => downloadReport(downloadExcel, 'xlsx')}
            downloadPdf={() => downloadReport(downloadPdf, 'pdf')}
            permissions={permissions}
            amount={total}
            white
            settingsCustom={settingsCustom()}
            onOpenGallery={handleOpenGallery}
          />
        </div>

        <div className={styles.rightSidebar}>
          {
            // eslint-disable-next-line no-nested-ternary
            checkedItems.length > 0
              ? (
                <MultipleEntries />
              )
              : selectedItem
                ? (
                  <EmployeeInfo />
                )
                : (
                  <div className={styles.empty}>
                    <TableIcon />
                    <div className={styles.empty__text}>
                      {t('Select any entry to get a detailed editable info or add an entry manually')}
                    </div>
                    { permissions.logbook_add_logs && (
                        <Button onClick={() => {
                          // setIsOpenAddEntry(true)
                          logbookEntryFormRef.current.show()
                        }}>
                          {t('Add entry')}
                        </Button>
                      )
                    }
                    {/* <AddEntry
                      open={isOpenAddEntry}
                      handleClose={() => setIsOpenAddEntry(false)}
                      onClickSave={handleClickAddEntry}
                    /> */}


                  </div>
                )
          }
          <ApproveEmpty
            open={!!approveEmptyVisible}
            handleClose={() => setApproveEmptyVisible(false)}
            title={t('Assign Empty Hours?')}
            text={
              <>
                {t("For {{name}} you are assigning the Empty Hours to the real Work Hours.", { name: selectedItem?.employee })}
                <br />
                {t("Are you sure you want to proceed? The process is not reversible.")}
              </>
            }
            buttonTitle={t('Assign')}
            approve={() => onApproveEmpty(approveEmptyVisible.id, approveEmptyVisible.type)}
          />
          <ApproveEmptySuccess
            open={!!approveEmptySuccess}
            handleClose={() => setApproveEmptySuccess(false)}
            text={t('Successfully assigned Empty hours to Work hours')}
          />
        </div>
      </div>
      <LogbookEntryForm
        ref={logbookEntryFormRef}
        companyId={companyId}
        onSuccess={sendRequest} />
      <EditCategory
        ref={editCategoryRef}
        onSubmit={handleSaveCategory} />
      <EditBonus
        ref={editBonusRef}
        companyId={companyId}
        onUpdate={sendRequest} />
      <AppGallery ref={galleryRef} />
    </MaynLayout>
  );
};
